import { Layout } from "antd";
import JobOpeningBody from "../../components/job-opening/JobPostOpeningBody";

const PostJobOpening = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh", paddingLeft: "20px", paddingRight: "20px" }} className="max-w-6xl w-full mx-auto">
        <JobOpeningBody />
      </Layout>
    </>
  );
};

export default PostJobOpening;
